module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-wall', {
    attrs: {
      "backImg": _vm.bgImg
    }
  }, [_c('p', {
    slot: "title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "map"
  }, [_c('el-amap', {
    attrs: {
      "vid": 'amap-vue',
      "center": _vm.mapCenter,
      "zoom": 5,
      "plugin": _vm.plugin
    }
  }, [_vm._l((_vm.markers), function(marker) {
    return _c('el-amap-marker', {
      key: marker.visible,
      attrs: {
        "position": marker.position,
        "events": marker.events,
        "visible": marker.visible,
        "draggable": marker.draggable
      }
    })
  }), _vm._v(" "), _vm._l((_vm.windows), function(window) {
    return _c('el-amap-info-window', {
      key: window.visible,
      attrs: {
        "position": window.position,
        "content": window.content,
        "open": window.open,
        "events": _vm.makerEvents
      }
    })
  })], 2)], 1), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "id": "markIcon1"
    }
  }, [_c('h3', [_vm._v("北京总部")]), _vm._v(" "), _c('p', {
    staticClass: "location"
  }, [_vm._v("北京市朝阳区慧忠里103号洛克")]), _vm._v(" "), _c('p', [_vm._v("时代中心A座703室")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "markIcon2"
    }
  }, [_c('h3', [_vm._v("上海总部")]), _vm._v(" "), _c('p', {
    staticClass: "location"
  }, [_vm._v("上海市徐汇区田林路140号越界")]), _vm._v(" "), _c('p', [_vm._v("创意园16号楼东2楼201室")])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v("商务合作")]), _vm._v(" "), _c('p', {
    staticClass: "tel"
  }, [_vm._v("4001-556-256(周一至周五)")]), _vm._v(" "), _c('p', {
    staticClass: "email"
  }, [_vm._v("cooperate@la-feng.com")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a90216f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/Contact.vue
// module id = 199
// module chunks = 1